import { render, staticRenderFns } from "./LoaderForm.vue?vue&type=template&id=2007c1ba&scoped=true&"
import script from "./LoaderForm.vue?vue&type=script&lang=js&"
export * from "./LoaderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2007c1ba",
  null
  
)

export default component.exports